import { apiService } from '@/services/api.service';

export interface PalettePickEntry {
  id: string;
  path: string | null;
  kind: 'block' | 'item';
  groupId: string;
}

// Palette agrégée sur TOUS les groupes (blocks + items), mise en cache pour la session.
let cache: Promise<PalettePickEntry[]> | null = null;

export function loadPackPalette(): Promise<PalettePickEntry[]> {
  if (!cache) {
    cache = (async () => {
      const gr = await apiService.getPacksGroups();
      const groups = gr.data?.groups ?? [];
      const parts = await Promise.all(
        groups.flatMap((g) => [
          apiService.getPackBlocks(g.id).then((r) => (r.data?.blocks ?? []).map((x) => ({ id: x.identifier, path: x.thumbnail, kind: 'block' as const, groupId: g.id }))),
          apiService.getPackItems(g.id).then((r) => (r.data?.items ?? []).map((x) => ({ id: x.identifier, path: x.iconPath, kind: 'item' as const, groupId: g.id }))),
        ]),
      );
      const seen = new Set<string>();
      return parts.flat().filter((e) => (seen.has(e.id) ? false : (seen.add(e.id), true)));
    })();
  }
  return cache;
}
